import { render, staticRenderFns } from "./OrderOptions.vue?vue&type=template&id=4355d829"
import script from "./OrderOptions.vue?vue&type=script&lang=js"
export * from "./OrderOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports